// source:https://github.com/vercel/next.js/pull/44436/files#diff-2f5596fa58e0c6b1fc2c6453e3a99ba4e25c585b657625c58f019b9e044e766c
// next.js built-in polyfill seems not working, manual polyfill here until more standard solution
// next.js support browser: https://nextjs.org/docs/architecture/supported-browsers
if (!Array.prototype.at) {
  Array.prototype.at = function at(n) {
    let i = Math.trunc(n) || 0;

    if (i < 0) i += this.length;

    if (i < 0 || i >= this.length) return undefined;

    return this[i];
  };
}

export {};
